import { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { Checkbox, Form, Input } from "antd";
import style from "./style.module.scss";
import { StorageService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { SimpleInput } from "../../../../common/components/simpleInput/SimpleInput";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../utilities/API_URLs";
import { DynamicUploadFile } from "../../../../common/components/Upload/DynamicUploadFile";
import { handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";

type CustomerRemovalFormType = {
  onFinish: () => void;
  initialValue?: any;
  isBag?: boolean;
};

const CustomerRemovalForm = ({
  onFinish,
  initialValue,
  isBag,
}: CustomerRemovalFormType) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(true);

  const onHandleChecked = () => {
    setChecked((prev: any) => !prev);
  };

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        destination: values.destination.value,
        deliveryNote: values.deliveryNote.value,
        ...(initialValue
          ? {
              id: initialValue?.["@id"].split("/").pop(),
            }
          : {}),
        isPartialGateOut: checked,
        ...(values.tonnageOut
          ? {
              tonnageOut: values.tonnageOut,
            }
          : {}),
      };

      const res = await StorageService.updateStorageLoad(dataToPost);
      if (res?.status === HttpStatusCode.Ok) {
        onFinish();
        form?.resetFields();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div>
          <div>
            <SimpleInput
              Form={Form}
              label="Client"
              name={"destination"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <InputSelect
                  uri={API_URLs.settings.customers.getCustomerSelect}
                  onChange={(e) => console.log(e)}
                />
              }
            />
          </div>
          <div className="mt-3">
            <SimpleInput
              Form={Form}
              label="Pièce jointe"
              name={"deliveryNote"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={<DynamicUploadFile form={form} name="deliveryNote" />}
            />
          </div>
          {isBag && (
            <>
              <div className="mt-3">
                <Checkbox
                  className={style.msc_text}
                  checked={checked}
                  onClick={onHandleChecked}
                >
                  Enlèvement partiel
                </Checkbox>
              </div>
              {checked && (
                <div className="mt-3">
                  <SimpleInput
                    Form={Form}
                    label="Tonnage"
                    name={"tonnageOut"}
                    rules={[
                      {
                        required: true,
                        message: `Ce champ est requis`,
                      },
                    ]}
                    customInput={<Input onKeyDown={handleNumericDecimalInput}/>}
                  />
                </div>
              )}
            </>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginTop: "1rem",
          }}
        >
          <CustomButton type="submit" isLoading={isLoadingSubmit}>
            Envoyer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};

export default CustomerRemovalForm;
